const pageNameKey = "otaFirmwareInstallationInProgress";

export const otaFirmwareInstallationInProgressEn = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware installation {itemName}{installationId} is in progress.",
    titleTemplateBackup:
      "Backup installation {itemName}{installationId} is in progress.",
    installationIdTemplate: " (Installation ID {ID})",
    descriptionFirmware: "Please wait while the firmware is being installed.",
    descriptionBackup: "Please wait while the backup is being installed.",
    showDetailsButtonText: "Show Details",
  },
};

export const otaFirmwareInstallationInProgressPtBr = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "A instalacao do firmware {itemName}{installationId} esta em andamento",
    titleTemplateBackup:
      "A instalacao do backup {itemName}{installationId} esta em andamento",
    installationIdTemplate: " (ID da instalacao {ID})",
    descriptionFirmware:
      "Por favor, aguarde enquanto o firmware esta sendo instalado.",
    descriptionBackup:
      "Por favor, aguarde enquanto o backup esta sendo instalado.",
    showDetailsButtonText: "Mostrar detalhes",
  },
};

export const otaFirmwareInstallationInProgressDe = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware-Installation {itemName}{installationId} laeuft",
    titleTemplateBackup:
      "Backup-Installation {itemName}{installationId} laeuft",
    installationIdTemplate: " (Installations-ID {ID})",
    descriptionFirmware:
      "Bitte warten Sie, waehrend die Firmware installiert wird.",
    descriptionBackup:
      "Bitte warten Sie, waehrend das Backup installiert wird.",
    showDetailsButtonText: "Details anzeigen",
  },
};

export const otaFirmwareInstallationInProgressZhHans = {
  [pageNameKey]: {
    titleTemplateFirmware: "固件安装 {itemName}{installationId} 正在进行中",
    titleTemplateBackup: "备份安装 {itemName}{installationId} 正在进行中",
    installationIdTemplate: "（安装 ID {ID}）",
    descriptionFirmware: "请稍候，固件正在安装中。",
    descriptionBackup: "请稍候，备份正在安装中。",
    showDetailsButtonText: "显示详情",
  },
};

export const otaFirmwareInstallationInProgressIt = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Installazione del firmware {itemName}{installationId} in corso",
    titleTemplateBackup:
      "Installazione del backup {itemName}{installationId} in corso",
    installationIdTemplate: " (ID installazione {ID})",
    descriptionFirmware: "Attendere mentre il firmware viene installato.",
    descriptionBackup: "Attendere mentre il backup viene installato.",
    showDetailsButtonText: "Mostra dettagli",
  },
};

export const otaFirmwareInstallationInProgressEs = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "La instalacion del firmware {itemName}{installationId} esta en curso",
    titleTemplateBackup:
      "La instalacion del respaldo {itemName}{installationId} esta en curso",
    installationIdTemplate: " (ID de instalacion {ID})",
    descriptionFirmware: "Espere mientras se instala el firmware.",
    descriptionBackup: "Espere mientras se instala el respaldo.",
    showDetailsButtonText: "Mostrar detalles",
  },
};

export const otaFirmwareInstallationInProgressNl = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware-installatie {itemName}{installationId} wordt uitgevoerd",
    titleTemplateBackup:
      "Backup-installatie {itemName}{installationId} wordt uitgevoerd",
    installationIdTemplate: " (Installatie-ID {ID})",
    descriptionFirmware: "Wacht terwijl de firmware wordt geinstalleerd.",
    descriptionBackup: "Wacht terwijl de backup wordt geinstalleerd.",
    showDetailsButtonText: "Details tonen",
  },
};

export const otaFirmwareInstallationInProgressTr = {
  [pageNameKey]: {
    titleTemplateFirmware:
      "Firmware kurulumu {itemName}{installationId} devam ediyor.",
    titleTemplateBackup:
      "Yedekleme kurulumu {itemName}{installationId} devam ediyor.",
    installationIdTemplate: "(Kurulum Kimliği {ID})",
    descriptionFirmware: "Ürün yazılımı yüklenirken lütfen bekleyin.",
    descriptionBackup: "Yedekleme yüklenirken lütfen bekleyin.",
    showDetailsButtonText: "Ayrıntıları Göster",
  },
};
